import "~/providers/sentry/sentry";
import "./bootstrap";

import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "sonner";

import "./../css/app.css";
import "react-loading-skeleton/dist/skeleton.css";

import { BrowserRouter } from "react-router-dom";

import { OursConsentBanner, Providers } from "./providers";
import { Router } from "./router";
import { ScrollToTop } from "./shared/components";

const root = document.getElementById("root");

if (!root) {
  throw new Error(
    "There's no #root div, something's wrong with our index.html",
  );
}

createRoot(root).render(
  <StrictMode>
    <Providers>
      <Toaster className="pointer-events-auto" richColors />

      <BrowserRouter>
        <ScrollToTop />
        <OursConsentBanner />
        <Router />
      </BrowserRouter>
    </Providers>
  </StrictMode>,
);
